import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';
import styled from 'styled-components';
import { Checkbox } from '~web/view/components/ui/form/checkbox-input.component';

interface Props {
  name: string;
  label: string;
  disabled?: boolean;
  onChangeHandler?: (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CheckboxField: React.FunctionComponent<Props> = ({
  name,
  label,
  disabled,
  onChangeHandler,
  ...rest
}) => {
  return (
    <Field
      name={name}
      type={'checkbox'}
      render={(renderProps): ReactNode => (
        <Wrapper>
          <Checkbox
            label={label}
            disabled={disabled}
            onChangeHandler={onChangeHandler}
            {...renderProps}
          />
        </Wrapper>
      )}
      {...rest}
    />
  );
};

const Wrapper = styled.div`
  width: 100%;
  > .checkbox-container {
    border: 2px solid ${(props): string => props.theme.colors.gray.v3};
    border-radius: 16px;
    min-height: 52px;
  }
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/field-checkbox.component.tsx